import { doApiCall } from "./v3/utils";
import {
  trackSpouseInviteCompleted,
  trackSpouseInviteFailed
} from "analytics";
import axios from "axios";
const {
  REACT_APP_MEMBER_PORTAL_ENDPOINT_URL,
  REACT_APP_REGISTRATION_API_URL
} = process.env;

/**
 * This endpoint confirms the spouse information, to send the invite
 * @returns {json} the data required from response
 */
export const postSpouseInvitation = (payload) => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "POST",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/spouse`,
    data: payload,
    body: JSON.stringify(payload)
  };
  return doApiCall(request).then((response) => {
    if (axios.isAxiosError(response)) {
      trackSpouseInviteFailed(response);
      return response;
    }
    trackSpouseInviteCompleted();
    return response;
  });
};

/**
 * This endpoint allows to get the spouse information before the invite
 * @returns {json} the data required from response
 */
export const getSpouseInformation = () => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "GET",
    url: `https://${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}/member/spouse`,
    responseType: "json"
  };

  return doApiCall(request);
};

export const getSpouseEligibility = () => {
  const request = {
    host: `${REACT_APP_MEMBER_PORTAL_ENDPOINT_URL}`,
    method: "GET",
    url: `https://${REACT_APP_REGISTRATION_API_URL}/user/spouse`,
    responseType: "json"
  };

  return doApiCall(request);
};
